import React from 'react'
import { FaLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { MdCall } from "react-icons/md";
import Globe from './Globe';


export default function JCLocation() {
  return (
    <div>
        <div className="location-section p-5 border-bottom border-secondary">
          <div className="sm-container">
          <div className="row mx-sm-5 mx-2 d-flex align-items-center g-4 text-light">

            <div className="col-lg-6 location-text">
              <div className="py-3">
                  <h5 className="fw-bold border-bottom border-secondary pb-2 mx-2">South Africa</h5>
                  <div className="cont-inner row p-2">

                    <div className="address my-2 col-1">
                    <span className=''><FaLocationDot/></span>
                    </div>
                    <div className="col-11  my-2">
                    3 Fairwinds Rd, Eversdal, Cape Town, 7536, South Africa
                    </div>

                    <div className="mail my-2 col-1">
                      <span className=''><MdEmail/></span>
                    </div>
                    <div className="col-11  my-2">business@jaggulasconsulting.com</div>

                    <div className="call my-2 col-1">
                      <span className=''><MdCall/></span>
                    </div>
                    <div className="col-11  my-2">
                    +27 740687900
                    </div>


                  </div>

              </div>
            </div>

            <div className="col-lg-6">
              <Globe />
            </div>

          </div>
          </div>
        </div>


    </div>


  )
}
